<div class="teamWrap" >
        <app-team></app-team>
</div>
